import {bindCostFieldsToUpdateTotals, createAccountForDepreciationAutocomplete, initDatePickers} from '../shared/capex-form-fields';

const BASE_URL = '/Finance/CapExTechnologyRequest';

export default function() {
    dropdowns();
    bindCostFieldsToUpdateTotals();
    initDatePickers();
    autocomplete();
};

const dropdowns = () => {
    const $computerTypeDropdown = $('select[name="EquipmentType"]');
    $computerTypeDropdown.kendoDropDownList({
        dataTextField: 'computerType', dataValueField: 'id', dataSource: {
            transport: {
                read: {
                    url: `${BASE_URL}/GetComputerTypeInformation`,
                },
            },
        },
        change(object) {
            let selectedItem = object.sender.dataSource.data()[object.sender.value()];
            if (selectedItem && selectedItem.price != null) {
                const $basePrice = $('[name=BasePrice]');
                $basePrice.data('kendoNumericTextBox').value(selectedItem.price);
                $basePrice.data('kendoNumericTextBox').trigger('change');

            }
        },
    });
};

const autocomplete = () => {
    createAccountForDepreciationAutocomplete(BASE_URL);

    $('.js-previous-cap-ex-list').kendoAutoComplete({
        dataSource: {
            schema: {
                autoSync: true,
                id: 'id',
                fields: {
                    id: {
                        type: 'number',
                    },
                    accountNumber: {
                        type: 'string',
                    },
                },
            },
            transport: {
                read: {
                    dataType: 'json',
                    type: 'GET',
                    url: `${BASE_URL}/GetPreviousCapitalExpenditures`,
                },
            },
        },
        dataTextField: 'RequestNumberFormatted',
        dataValueField: 'RequestNumber',
        filter: 'contains',
        placeholder: 'Search Technology Capital Expenditures',
        noDataTemplate: 'No matching Capital Expenditures found.',
    }).data('kendoAutoComplete');
};
